<waitLoading *ngIf="!isLoaded()"></waitLoading>
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 alert alert-info" *ngIf="!isLoaded()">
        <span class="w-100 text-center">
          <span class="m-xs" class="leyenda">
            <i class="fa fa-spinner fa-2x loading-spin" aria-hidden="true"></i>
          </span>
        </span>
      </div>
      <div class="col-12" *ngIf="isLoaded()">
        <p-table [value]="elements" [responsive]="true">
          <ng-template pTemplate="header">
            <tr>
              <th [style.width]="'30%'">{{'AwardCriteria.formula'|translate}}</th>
              <th>{{'General.description'|translate}}</th>
              <th [style.width]="'10%'">{{'AwardCriteriaFormula.type'|translate}}</th>
              <th class="action-column-2x">{{'General.actions'|translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-formula>
            <tr>
              <td>
                <span class="p-column-title">{{'AwardCriteria.formula'|translate}}</span> {{ formula.name }}
              </td>
              <td>
                <span class="p-column-title">{{'General.description'|translate}}</span>
                <p [innerHTML]="formula.description"></p>
              </td>
              <td>
                <span class="p-column-title">{{'AwardCriteria.type'|translate}}</span> {{ formula.type }}
              </td>
              <td class="action-column-2x">
                <div class="btn-group">
                  <button class="btn btn-sm btn-primary t-action-button"
                    [attr.disabled]="!formula.editable ? 'disabled' : null" aria-expanded="false"
                    title="{{ 'General.delete' | translate}}" (click)="delete(formula)">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                  <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                    title="{{ 'General.visualize' | translate}}" (click)="edit(formula, false)">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </button>
                  <button class="btn btn-sm btn-primary t-action-button"
                    [attr.disabled]="!formula.editable ? 'disabled' : null" aria-expanded="false"
                    title="{{ 'General.edit' | translate}}" (click)="edit(formula, true)">
                    <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="text-center">
              <td colspan="3"><span>{{ 'General.noData' | translate }}</span></td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="col-12 alert alert-info" *ngIf="isLoaded()&&!isLoadedResult()">
        <span>No se han cargado datos</span>
      </div>
    </div>
  </div>
</div>